import React from "react"
import PropTypes from "prop-types"
import Accordion from "./Accordion"

const Navigation = props => {
  const { navigation } = props

  return (
    <>
      <div className="content-container">
        <div className="flex items-center flex-wrap m-0 lg:min-h-[40px]">
          <Accordion collection={navigation} />
        </div>
      </div>
    </>
  )
}

Navigation.propTypes = {
  navigation: PropTypes.array
}

export default Navigation
